import React, { useState } from 'react';
import { Space, Badge, List, Row, Button, Spin, Grid, AutoComplete, App } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { CaretUpOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
var ClassItem = models.classes.ClassItem;
var TeamSource = models.teams.TeamSource;
var TeamItem = models.teams.TeamItem;
import { TeamsTable } from './TeamsTable';
import { TeamEdit } from './TeamEdit';
const { useBreakpoint } = Grid;
export const TeamClassList = (props) => {
    const { event_id, competition_id, disabled } = props;
    const [classes, loading] = Stream(ClassesSource(competition_id));
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { notification } = App.useApp();
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [teamItem, setTeamItem] = useState();
    const [results, setResults] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const handleSearch = async (value) => {
        setResults([]);
        setOptions([]);
        const numberSearch = parseInt(value, 10);
        if (value.length < 3 && !numberSearch) {
            return;
        }
        setIsLoading(true);
        const result = await Api.call(TeamSource(competition_id).url, "search-teams", {
            query: value
        })
            .catch(err => {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
        setIsLoading(false);
        setOptions(result ? searchResult(result) : []);
        setResults(result ? result : []);
    };
    const searchResult = (teams) => teams.map(team => {
        return {
            value: team.team_id,
            label: React.createElement(Space, { style: team.team_cancelled > 0 ? { textDecoration: 'line-through' } : {} },
                team.team_start_number,
                TeamItem.getFullNameWithOrg(team),
                team.team_class)
        };
    });
    const onSelect = (value) => {
        const foundTeam = results.find(a => a.team_id === value);
        setTeamItem(foundTeam);
        setVisibleEdit(true);
        setOptions([]);
        setSearchValue('');
    };
    const duplicateTeam = (team) => {
        const duplicatedTeam = {
            ...team,
            class_id: undefined,
            team_id: undefined,
            team_class: undefined,
            team_placement: '',
            team_sum: ''
        };
        setTeamItem(duplicatedTeam);
    };
    if (loading) {
        return React.createElement(Spin, null);
    }
    return (React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } },
        React.createElement(Space.Compact, { style: { width: '100%' } },
            React.createElement(AutoComplete, { options: options, onSelect: onSelect, style: { width: '100%' }, size: "large", value: searchValue, onChange: (value) => {
                    setSearchValue(value);
                    if (!value) {
                        setOptions([]);
                        setResults([]);
                    }
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter' && searchValue) {
                        void handleSearch(searchValue);
                    }
                }, placeholder: _T('common.search'), allowClear: true }),
            React.createElement(Button, { type: "primary", size: "large", loading: isLoading, disabled: !searchValue, onClick: () => handleSearch(searchValue) }, _T('common.search'))),
        React.createElement(List, { size: 'small', itemLayout: 'vertical', dataSource: classes, bordered: true, renderItem: (classItem) => (React.createElement(TeamClassListItem, { event_id: event_id, competition_id: competition_id, classItem: classItem, disabled: disabled })) }),
        React.createElement(TeamEdit, { competition_id: competition_id, visible: visibleEdit, teamItem: teamItem, onClose: () => setVisibleEdit(false), onDuplicate: duplicateTeam, disabled: disabled })));
};
const TeamClassListItem = (props) => {
    const { event_id, competition_id, classItem, disabled } = props;
    const screens = useBreakpoint();
    const [expanded, setExpanded] = useState(false);
    const handleClickExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };
    return (React.createElement(List.Item, { style: { padding: 0 } },
        React.createElement(List.Item.Meta, { style: { marginBottom: 0 }, description: React.createElement(Row, { justify: 'space-between', onClick: handleClickExpand, style: { padding: 8 } },
                React.createElement(Space, null,
                    parseInt(classItem.class_group_id) > 0 &&
                        React.createElement(CaretUpOutlined, null),
                    React.createElement(Button, { type: "text", onClick: handleClickExpand },
                        React.createElement(Space, null,
                            ClassItem.getClassLabel(classItem),
                            screens.sm &&
                                React.createElement(Badge, { overflowCount: 999, count: classItem.class_count })))),
                React.createElement(Space, null, expanded ? React.createElement(DownOutlined, { onClick: handleClickExpand }) : React.createElement(RightOutlined, { onClick: handleClickExpand }))) }),
        expanded &&
            React.createElement(TeamsTable, { key: classItem.class_id, event_id: event_id, competition_id: competition_id, classItem: classItem, disabled: disabled })));
};
